import React from "react";
import { Row, Col } from "antd";
import "./index.scss";

const ListItem = ({ columns = [], item, index, size }) => {
  let content = [];
  columns.map((i, k) => {
    content.push(
      <Col
        span={i.span}
        key={`${i.dataIndex}_${k}`}
        className="tc textOverFlow plr5"
      >
        {i.render
          ? i.render(item[i.dataIndex], item, index)
          : item[i.dataIndex] != null
            ? item[i.dataIndex]
            : "-"}
      </Col>
    );
  });
  return (
    <Row
      className={`list-item ${item.level == 2 && "list-item-l"} ${item.level == 3 && "list-item-h"} ${size === 'large' && "list-item-large"}`}
    >
      {content}
    </Row>
  );
};

export default ({ data = [], columns, size }) => {
  return data.map((item, index) => {
    return <ListItem columns={columns} item={item} index={index} size={size} key={index}/>;
  });
};
